import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../../config/siteConfig";
import Icon from "../ui/Icon";
import SealChip from "../ui/SealChip";

const LEGAL_LINKS = [
  { to: "/legal?tab=aviso", label: "Rättsligt meddelande" },
  { to: "/legal?tab=terms", label: "Användarvillkor" },
  { to: "/legal?tab=privacy", label: "Integritetspolicy" },
];

const Footer = () => {
  const { brand, uiCopy, legal, sealLabels, contact } = siteConfig;
  const year = new Date().getFullYear();
  // Label du sceau « pago seguro » : issu de la config si dispo, fallback sûr sinon.
  const secureLabel = sealLabels?.securePayment || "Säker betalning";
  // E-mail de support : issu de la config si dispo (fallback-safe : on ne rend rien si vide).
  const supportEmail = contact?.supportEmail || "";

  return (
    <footer className="bg-slate-900 border-t border-slate-800/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 mb-16">
          <div className="col-span-2 lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-gradient-to-br from-indigo-700 to-sky-600 p-2.5 rounded-xl">
                <svg
                  className="w-6 h-6 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  />
                </svg>
              </div>
              <div className="flex flex-col leading-none">
                <span className="text-xl font-extrabold text-white">
                  {brand.namePrefix}
                  <span className="text-indigo-400">{brand.nameSuffix}</span>
                </span>
                {brand.subBrand && (
                  <span className="text-[10px] font-bold text-slate-400 mt-0.5 tracking-tighter">
                    {brand.subBrand}
                  </span>
                )}
              </div>
            </div>
            <p className="text-sm text-slate-400 mb-6 leading-relaxed">
              {brand.tagline}
            </p>
            <SealChip
              label={secureLabel}
              icon="lock"
              className="ring-indigo-400/25 bg-indigo-500/10 text-indigo-300"
            />
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">
              {uiCopy.landing.productNavLabel}
            </h3>
            <ul className="space-y-3">
              {uiCopy.landing.productLinks.map((link, idx) => (
                <li key={idx}>
                  <a
                    href={link.href}
                    className="nav-underline text-sm text-slate-400 hover:text-indigo-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="/temario/"
                  className="nav-underline text-sm text-slate-400 hover:text-indigo-400 transition-colors"
                >
                  {uiCopy.landing?.temarioLabel || "Kunskapsöversikt och gratis test"}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">Legal</h3>
            <ul className="space-y-3">
              {LEGAL_LINKS.map((link, idx) => (
                <li key={idx}>
                  <Link
                    to={link.to}
                    className="nav-underline text-sm text-slate-400 hover:text-indigo-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              {supportEmail && (
                <li>
                  <a
                    href={`mailto:${supportEmail}`}
                    className="nav-underline inline-flex items-center gap-2 text-sm text-slate-400 hover:text-indigo-400 transition-colors"
                  >
                    <Icon
                      name="document-check"
                      className="w-4 h-4 text-indigo-400"
                    />
                    {supportEmail}
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800/80 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-500 tabular-nums">
            © {year} {brand.name} {brand.subBrand} — Drivs av{" "}
            {legal.operatorName}. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6">
            <span className="inline-flex items-center gap-2 text-sm text-slate-500">
              <Icon name="flag" className="w-4 h-4 text-indigo-400" />
              {brand.madeInLabel}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
